
import {getImageOfSize, getPostThumbnailsAttributes} from "@/utils/getImagePaths.js";

export default {
  name: "RelatedPosts",
  props: {
    posts: Array,
    currentPostID: String,
  },
  computed: {
    relatedPosts() {
      const currentIndex = this.posts.findIndex(
        (post) => post.id === this.currentPostID
      );

      // If array has 1 or 2 elements
      if (this.posts.length === 1) {
        return [];
      } else if (this.posts.length === 2) {
        if (currentIndex === 0) {
         return [this.posts[1]];
        } else {
          return [this.posts[0]];
        }
      }

      let startIndex = currentIndex + 1;
      let endIndex = currentIndex + 2;

      // If array has more than 2 elements
      if (currentIndex === this.posts.length - 1) {
        startIndex = 0;
        endIndex = 1;
      } else if (currentIndex === this.posts.length - 2) {
        endIndex = 0;
      }

      return [this.posts[startIndex], this.posts[endIndex]];
    },
  },
  methods: {
    getImageOfSize,
    getPostThumbnailsAttributes,
    mouseEvent(state, postID) {
      const image = document.getElementById('related-' + postID)

      this.$gsap.killTweensOf(image);

      if (state) {
        this.$gsap.to(image, {
          duration: 2,
          ease: "power4",
          scale: 1.1,
        });
      } else {
        this.$gsap.to(image, {
          duration: 0.7,
          ease: 'expo',
          scale: 1
        });
      }
    },
  }
}
